const formatCurrency = (value = 0, showCents = true): string => {
  const formatter = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: showCents ? 2 : 0,
    minimumFractionDigits: showCents ? 2 : 0,
  });
  return formatter.format(value);
};

export default formatCurrency;
